package org.example.willfreightnew.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.willfreightnew.NavLinkStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.example.willfreightnew.toSitePalette
import org.jetbrains.compose.web.css.px
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.example.willfreightnew.HeaderLinkStyle
import org.example.willfreightnew.components.models.Section

val FooterStyle = CssStyle.base {
    Modifier
        .backgroundColor(colorMode.toSitePalette().contrastBackground)
        .padding(topBottom = 1.5.cssRem, leftRight = 10.percent)
}

@Composable
private fun NavLink(path: String, text: String) {
    Link(path, text, modifier = NavLinkStyle.toModifier(), variant = UndecoratedLinkVariant.then(UncoloredLinkVariant))
}

@Composable
private fun HeaderLink(path: String, text: String) {
    Link(path,
        text,
        modifier = HeaderLinkStyle.toModifier(),
        variant = UndecoratedLinkVariant.then(UncoloredLinkVariant))
}

@Composable
private fun MenuItems() {
    Section.entries.forEach { section ->
        HeaderLink(path = section.path, text = section.caps)
    }
}

@Composable
fun Footer(modifier: Modifier = Modifier) {
    val breakpoint = rememberBreakpoint()
    Column(FooterStyle.toModifier().then(modifier)) {
        Row(horizontalArrangement = Arrangement.SpaceBetween, modifier = Modifier
            .fillMaxWidth(85.percent)
            .height(50.px)
            .margin(top = 10.px, bottom = 40.px)) {
            Column(modifier = Modifier
                .fillMaxHeight()
                .width(100.percent)
            ) {

            }


        }
        Row(Modifier
            .fillMaxWidth()
            .margin(bottom = 15.px)
            .gap(if(breakpoint >= Breakpoint.MD) 90.px else 20.px),
            horizontalArrangement = Arrangement.Center,) {
            MenuItems()
        }
        Box(
            modifier = Modifier
                .margin(bottom = 10.px)
                .height(2.px)
                .width(800.px)
                .align(Alignment.CenterHorizontally)
                .backgroundColor(ColorMode.current.toSitePalette().faintText)
                .borderRadius(r = 50.px)
        )

        Row(
            verticalAlignment = Alignment.Bottom,
            horizontalArrangement = Arrangement.Center,
            modifier = Modifier
                .fillMaxWidth()
                .color(ColorMode.current.toSitePalette().faintText)
                .fontSize(0.75.cssRem)
        ) {
            SpanText("This site does not record your IP address, collect any data, or set any cookies or trackers. ")
            SpanText("Web Design and Photography by Saga Robin | All Content © Will Freight Services Limited 2026")
        }
    }
}

